import React from "react";

const withTooltip = Component =>
  class extends React.Component {
    constructor() {
      super();
      this.state = {};
      this._addTooltipEvent = this._addTooltipEvent.bind(this);
      this._removeTooltipEvent = this._removeTooltipEvent.bind(this);
    }

    showTooltip(object, message, location, minLeft, minTop, left, top) {
      var self = this;

      // If tooltip remove it
      this.removeTooltip();

      // give enough time to reset before setting state
      setTimeout(function() {
        self.setState({
          tooltip: {
            object: object,
            message: message,
            location: location,
            minLeft: minLeft,
            minTop: minTop,
            left: left,
            top: top
          }
        });
      }, 0);
    }

    removeTooltip() {
      this.setState({ tooltip: undefined });
    }

    // Add the tooltip
    _addTooltipEvent(e) {
      var targetObject = $(e.currentTarget);
      if ($(e.currentTarget).data("target-dom-id")) {
        targetObject = $("#" + $(e.currentTarget).data("target-dom-id"));
      }
      this.showTooltip(
        targetObject,
        $(e.currentTarget).data("tooltip"),
        $(e.currentTarget).data("tooltip-location"),
        $(e.currentTarget).data("tooltip-min-left"),
        $(e.currentTarget).data("tooltip-min-top"),
        $(e.currentTarget).data("tooltip-left"),
        $(e.currentTarget).data("tooltip-top")
      );
    }

    // Remove the tooltip
    _removeTooltipEvent() {
      this.removeTooltip();
    }

    render() {
      return (
        <Component
          addTooltip={this._addTooltipEvent}
          removeTooltip={this._removeTooltipEvent}
          {...this.props}
          {...this.state}
        />
      );
    }
  };

export default withTooltip;
